<div fxLayout="column" class="neq-dialog">
    <span>{{message}}</span>
    <div class="asi-container" fxLayout="row" fxLayoutAlign="center center">
      <button pButton class="neq-primeng-button-text" label="{{'msg.common.validation.yes' | translate}}" (click)="process()"></button>
      <button pButton class="neq-primeng-button-text" label="{{'msg.common.validation.no' | translate}}" (click)="cancel()"></button>
    </div>
</div>
